import { render, staticRenderFns } from "./ImageBox.vue?vue&type=template&id=6f78021d&scoped=true&"
import script from "./ImageBox.vue?vue&type=script&lang=ts&"
export * from "./ImageBox.vue?vue&type=script&lang=ts&"
import style0 from "./ImageBox.vue?vue&type=style&index=0&id=6f78021d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f78021d",
  null
  
)

export default component.exports